import axios from "utils/axios";
import * as types from "./ActionTypes";
import { API_URL } from "configs";
import { showSuccessModal } from "actions";

// Common helpers
const loader = (label) => ({
  type: types.SHOW_LOADER,
  common_loader_label: label,
});
const hideLoader = () => ({ type: types.HIDE_LOADER });

const snackbar = (msg, type = "general_error") => ({
  type: types.SHOW_SNACKBAR,
  snackbar_notification: msg,
  snackbar_notification_type: type,
});

const handleError = (error, dispatch, validationType) => {
  const res = error?.response;
  if (res?.status === 422) {
    dispatch({ type: validationType, validation_error: res.data.errors });
  } else {
    dispatch(snackbar(res?.data?.error || `${res?.status} ${res?.statusText}`));
  }
};

export const queueRedirectToList = () => ({ type: types.QUEUES_REDIRECT });

const fetchSuccess = (type, listKey) => (data) => ({
  type,
  [listKey]: data,
});

const getSuccess = (type) => (data, action) => ({
  type,
  record: data,
  actionType: action,
});

export const hideQueueValidationError = (field_key) => ({
  type: types.HIDE_QUEUES_FIELD_VALIDATION_ERROR,
  field_key: field_key,
});

//
// =============================
// CRUD + Dropdown + Export
// =============================
//

// 🔹 Fetch Queues List
export const fetchQueues =
  (params = {}) =>
  (dispatch) => {
    dispatch({ type: types.QUEUES_REQUEST });
    dispatch(loader());

    axios
      .post(`${API_URL}admin/queues/list`, params, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((res) => {
        console.log("fetchQueues_res", res);
        dispatch(hideLoader());
        dispatch(
          fetchSuccess(types.QUEUES_SUCCESS, "queuesList")(res.data) // ✅ only data array
        );
      })
      .catch((err) => {
        dispatch(hideLoader());
        handleError(err, dispatch, types.QUEUES_VALIDATION_ERROR);
      });
  };

// 🔹 Get Queue by ID
export const getQueueById =
  (id, actionType, object_viewed_id) => (dispatch) => {
    dispatch({ type: types.QUEUES_REQUEST });
    dispatch(loader());

    axios
      .get(`${API_URL}admin/queues/${id}`, {
        params: { object_viewed_id },
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((res) => {
        dispatch(hideLoader());
        dispatch(getSuccess(types.QUEUES_GET_SUCCESS)(res.data, actionType));
      })
      .catch((err) => {
        dispatch(hideLoader());
        handleError(err, dispatch, types.QUEUES_VALIDATION_ERROR);
      });
  };

// 🔹 Create or Update Queue
export const createOrUpdateQueue =
  (data, method = "POST", object_viewed_id) =>
  (dispatch) => {
    dispatch({ type: types.QUEUES_REQUEST });
    dispatch(loader());

    const url =
      method === "POST"
        ? `${API_URL}admin/queues`
        : `${API_URL}admin/queues/${data.id}`;

    axios({
      url,
      method,
      data,
      params: { object_viewed_id },
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
      .then(() => {
        dispatch(hideLoader());
        dispatch(
          showSuccessModal(
            `Queue ${method === "POST" ? "created" : "updated"} successfully`
          )
        );
        dispatch(queueRedirectToList());
      })
      .catch((err) => {
        dispatch(hideLoader());
        handleError(err, dispatch, types.QUEUES_VALIDATION_ERROR);
      });
  };

// 🔹 Delete Queue
export const deleteQueue = (id, object_viewed_id) => (dispatch) => {
  dispatch({ type: types.QUEUES_REQUEST });
  dispatch(loader());

  axios
    .delete(`${API_URL}admin/queues/${id}`, {
      params: { object_viewed_id },
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(() => {
      dispatch(hideLoader());
      dispatch(snackbar("Queue deleted", "success"));
      dispatch(fetchQueues({ object_viewed_id })); // Refresh list
    })
    .catch((err) => {
      dispatch(hideLoader());
      handleError(err, dispatch, types.QUEUES_VALIDATION_ERROR);
    });
};

// 🔹 Dropdown for Queues
export const fetchQueuesDropdown = (params) => (dispatch) => {
  dispatch({ type: types.QUEUES_REQUEST });

  axios
    .get(`${API_URL}admin/queues/dropdown`, {
      params,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then((res) => {
      dispatch(
        fetchSuccess(
          types.QUEUES_DROPDOWN_SUCCESS,
          "queuesDropdownList"
        )(res.data)
      );
    })
    .catch((err) => {
      handleError(err, dispatch, types.QUEUES_VALIDATION_ERROR);
    });
};

// 🔹 Export Queues
export const exportQueues = (extraFilters, object_viewed_id) => (dispatch) => {
  dispatch(loader("Exporting..."));
  const url = `${API_URL}admin/queues/export`;

  axios
    .post(
      url,
      { ...extraFilters, object_viewed_id },
      {
        responseType: "blob",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then((response) => {
      const urlBlob = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = urlBlob;

      const contentDisposition = response.headers["content-disposition"];
      let filename = "queues.xlsx";
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="?(.+)"?/);
        if (filenameMatch?.length > 1) filename = filenameMatch[1];
      }

      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(urlBlob);
      dispatch(hideLoader());
    })
    .catch((error) => {
      dispatch(hideLoader());
      handleError(error, dispatch);
    });
};
